/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_WeekendInputs */



/**
* | output |
* | --- |
* | "Show Saturday & Sunday" |
*
* @param {Settings_WeekendInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_weekend = /** @type {((inputs?: Settings_WeekendInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_WeekendInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toon zaterdag & zondag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher samedi et dimanche")
	return /** @type {LocalizedString} */ ("Show Saturday & Sunday")
});